<template>
  <v-col>
    <v-row>
      <calcolatori :article="article" />
    </v-row>
    <br>
    <v-row justify="end">
      <v-btn
        color="primary"
        class="mb-6 br-4"
        @click="downloaGiacenza"
      >Scarica XLS Giacenze</v-btn>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        xl="9"
        class="order-last order-xl-first"
      >
        <v-row>
          <v-card style="width: 100%">
            <v-card-title class="pb-8">
              <v-btn
                color="primary"
                @click="CHANGE_ACCESSORI_COMPONENT('Insert')"
              >Nuovo Accessorio</v-btn>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Cerca"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="filteredAccessories"
              class="elevation-1"
              single-expand
              show-expand
              :search="search"
              :items-per-page="100"
              :footer-props="{
            itemsPerPageAllText: 'Tutti',
            itemsPerPageOptions: [15, 50, 100, -1],
            itemsPerPageText: 'Accessori per pagina',
          }"
              @click:row="rowClickHandler"
            >

              <template v-slot:top>
                <edit-form
                  :item="selectedItem"
                  @edit-submit="triggerSnack($event)"
                />
              </template>

              <template v-slot:item.amount="{ header, item }">
                <v-icon
                  small
                  :class="{'mr-2': true, 'red--text text--darken-1': item.amount == 0, 'green--text text--darken-1': item.amount != 0}"
                  v-if="header.text.length == 0"
                >
                  mdi-circle
                </v-icon>
                <span v-else>{{item.amount}}</span>
              </template>

              <template v-slot:item.action="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="edit(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>

              <template v-slot:no-data>
                <v-btn
                  color="primary"
                  @click="fetchAccessories"
                >Ricarica</v-btn>
              </template>

              <template v-slot:item.cost="{ item }">
                <span>{{item.cost || '0'}}€</span>
              </template>

              <template v-slot:item.price="{ item }">
                <span>{{item.price || '0'}}€</span>
              </template>

              <template v-slot:item.posix="{ item }">
                <span>{{new Date(item.posix).toLocaleString('it-IT', {'day': '2-digit', 'month': '2-digit', 'year': 'numeric', })}}</span>
              </template>
              <template v-slot:expanded-item="{ item, headers }">
                <td
                  :colspan="headers.length"
                  class="px-0"
                >
                  <article-orders
                    :article="item"
                    v-on:edit-accessory="edit"
                  />
                </td>
              </template>
            </v-data-table>
            <snack-notification :snack="snack" />
          </v-card>
        </v-row>
      </v-col>

      <v-col>
        <filters v-on:filters-changed="applyFilters" />
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
  import axios from 'axios'
  import { mapMutations } from 'vuex'

  import Calcolatori from './../../dashboard/tools/Calcolatori'
  import ArticleOrders from './ArticleOrders'
  import EditForm from './EditForm'
  import SnackNotification from './../../SnackNotification'
  import Filters from './Filters.vue'

  export default {
    name: 'Index',
    components: {
      Calcolatori,
      EditForm,
      SnackNotification,
      ArticleOrders,
      Filters
    },
    data: () => ({
      today: `${(new Date()).getDate()}-${(new Date()).getMonth() + 1}-${(new Date()).getFullYear()}`,
      search: '',
      headers: [
        { text: '', value: 'amount', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Fornitore', value: 'supplier_name', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'EAN', value: 'serial_code', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Marchio', value: 'brand', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Prodotto', value: 'model', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Colore', value: 'color', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Modello', value: 'desctiption', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Prezzo', value: 'price', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Quantità', value: 'amount', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: '', value: 'data-table-expand' },
      ],
      accessories: [],
      filteredAccessories: [],
      item: {},
      snack: {
        error: null,
        visible: null,
        message: null
      },
      config: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        }
      },
      row: {
        articolo: '17',
        pagato: '',
        ricarico: '',
        pap: '',
        iva: '',
        utile: '',
        incassato: '',
        rate: '',
        utileFinale: '',
        costoRate: '',
        rata: '',
        incidenza: '',
        dilapay: {
          fisso: '',
          variabile: ''
        }
      }
    }),

    computed: {
      selectedItem() {
        return this.item
      },
      article() {
        return this.row
      }
    },

    methods: {
      ...mapMutations([
        'CHANGE_ACCESSORI_COMPONENT',
        'CHANGE_ACCESSORI_EDIT'
      ]),

      async fetchAccessories() {
        try {

          let accessoryMap = { id: 0, index: 0, amount: 0 }
          let filterId = 0

          let {
            data
          } = await axios.get(`${process.env.VUE_APP_API}/accessories/fetch`, this.config)

          let sortedData = data.sort((a, b) => {
            return a.accessory_id - b.accessory_id
          })

          let result = sortedData

          sortedData.map((el, index) => {

            if (accessoryMap.id != el.accessory_id) {

              accessoryMap.id = el.accessory_id
              accessoryMap.index = index
              accessoryMap.amount = el.amount

              result[accessoryMap.index].orders = []
              result[accessoryMap.index].amount = accessoryMap.amount
              result[accessoryMap.index].orders.push({
                id: el.id,
                cost: el.cost,
                amount: el.amount,
                posix: el.posix,
                supplier_id: el.s_id,
                supplier_name: el.supplier_name,
              })
            } else {

              accessoryMap.amount += el.amount

              result[accessoryMap.index].amount = accessoryMap.amount
              result[accessoryMap.index].orders.push({
                id: el.id,
                cost: el.cost,
                amount: el.amount,
                posix: el.posix,
                supplier_id: el.s_id,
                supplier_name: el.supplier_name,
              })

            }

            return el
          })

          result = result.filter(el => {

            return el.orders
          })

          this.accessories = result
        } catch (error) {

          console.log(error)

          this.accessories = []
        }
      },

      rowClickHandler(data) {

        const cost = data.orders.filter(el => el.amount > 0)

        if (cost.length > 0) {
          this.row = {
            articolo: data.is_art_17 === 0 ? '36' : '17',
            pagato: cost[cost.length - 1].cost,
            ricarico: '',
            pap: data.price,
            iva: '',
            utile: '',
            incassato: '',
            rate: '',
            utileFinale: '',
            costoRate: '',
            rata: '',
            incidenza: '',
            dilapay: {
              fisso: '',
              variabile: ''
            }
          }
        } else {
          this.row = {
            articolo: '17',
            pagato: '',
            ricarico: '',
            pap: '',
            iva: '',
            utile: '',
            incassato: '',
            rate: '',
            utileFinale: '',
            costoRate: '',
            rata: '',
            incidenza: '',
            dilapay: {
              fisso: '',
              variabile: ''
            }
          }
        }
      },

      async downloaGiacenza() {
        let { data } = await axios.get(`${process.env.VUE_APP_API}/downloads/giacenza-accessories`, this.config)

        var fileURL = window.URL.createObjectURL(new Blob([data]))
        var fileLink = document.createElement('a')

        const name = `[${this.today}]report_giacenze_accessori.xls`

        fileLink.href = fileURL
        fileLink.setAttribute('download', name)
        document.body.appendChild(fileLink)

        fileLink.click()
      },

      edit(val) {

        let item = val.item
        let index = val.index

        item.posix = item.orders[index].posix
        item.amount = item.orders[index].amount
        item.cost = item.orders[index].cost
        item.supplier_id = item.orders[index].supplier_id
        item.supplier_name = item.orders[index].supplier_name

        this.item = item
        this.CHANGE_ACCESSORI_EDIT(true)
      },

      triggerSnack(e) {
        if (e === 'reset') {

          this.snack = Object.assign({}, {
            error: null,
            visible: null,
            message: null
          })
        } else if (e === 'ok') {

          this.snack = Object.assign({}, {
            visible: true,
            error: false,
            message: 'Articolo modificato correttamente!'
          })

          this.fetchAccessories()

        } else if (e === 'error') {

          this.snack = Object.assign({}, {
            visible: true,
            error: true,
            message: 'Errore nella modifica.'
          })
        }
      },

      async applyFilters(e) {
        if (this.accessories.length === 0) {
          await this.fetchAccessories()
        }

        switch (true) {
          case e.inStock == true && e.notInStock == true:

            this.filteredAccessories = this.accessories
            break

          case e.inStock == true && e.notInStock == false:

            this.filteredAccessories = this.accessories.map(el => {
              if (el.amount > 0) {
                return el
              }
            }).filter(el => el != null)
            break

          case e.inStock == false && e.notInStock == true:

            this.filteredAccessories = this.accessories.map(el => {
              if (el.amount == 0) {
                return el
              }
            }).filter(el => el != null)
            break

          default:
            this.filteredAccessories = []
        }
      }
    }
  }
</script>

<style>
</style>